export default {
  apiServerUrl: 'https://pkitchen.the-dev.org/', // 'https://localhost:8080/',
  isDebugMode: false
};
